/* tslint:disable */
import { OnInit, Component } from "@angular/core";
import { NgbDate } from "@ng-bootstrap/ng-bootstrap";
import { AuthService } from "../../../../../../../shared/services/auth.service";
import {
  FormGroup,
  FormBuilder,
  FormArray,
  FormControl,
  ValidatorFn,
} from "@angular/forms";
import {
  DatoPaginadoModel,
  Paging,
} from "src/app/shared/models/dato-paginado.model";
import { CamaraComercioEntry } from "src/app/shared/entrys/camara-comercio";
import { RolesUsuario } from "src/app/shared/enumeraciones/roles-usuario.enum";
import { EstablecimientoComercioService } from "../../../prestador/establecimiento-comercio/establecimiento-comercio.service";
import { HttpEventType } from "@angular/common/http";
import { PagosParafiscalesService } from "./pagos-parafiscales.service";
import * as FileSaver from "file-saver";

@Component({
  selector: "app-pagos-parafiscales",
  templateUrl: "./pagos-parafiscales.component.html",
  styleUrls: ["./pagos-parafiscales.component.scss"],
})
export class PagosParafiscalesComponent implements OnInit {
  dataTabla: DatoPaginadoModel;
  headerTabla: Array<string>;
  formUsuario: FormGroup;
  selectUsuario: any;
  camarasLista: Array<CamaraComercioEntry>;
  paginaActual: number;
  adminSuper = RolesUsuario.AdministradorSuper;
  prestador = RolesUsuario.Prestador;
  adminCC = RolesUsuario.AdministradorCC;
  columnas: Array<any> = [];
  columnasEnvio: any;
  // filtros
  filtro: FormGroup;
  formCheck: FormGroup;
  public isCollapsed = true;
  isExportar = true;
  camaraComercio: string;
  // Selects
  categoria: Array<any> = [];
  sub_categoria: Array<any> = [];
  tipoRNT: Array<any> = [];
  exportarForm: FormGroup;
  fecha_inicio: any;
  exportarList = [
    { id: "CAMARA COMERCIO", name: "Cámara de Comercio" },
    { id: "CODIGO_RNT", name: "Número Rnt" },
    { id: "RAZON_SOCIAL", name: "Nombre o Razón social" },
    { id: "NOMBRE_REPRESENTANTE_LEGAL", name: "Identificación RL" },
    { id: "CATEGORIA", name: "Categoría" },
    { id: "SUBCATEGORIA", name: "Sub Categoría" },
    { id: "ULTIMO_ANIO_RENOVACION", name: "Último año renovación" },
    { id: "SOLICITUD", name: "Solicitud" },
    { id: "ESTADO SOLICITUD", name: "Estado Solicitud" },
    { id: "NUMERO RADICACION", name: "Número Radicación" },
    { id: "FECHA_RADICACION", name: "Fecha Radicación" },
    { id: "APLICA_PAGO_PARAFISCALES", name: "Aplica Pago Parafiscales" },
    { id: "TOTAL_VENTAS", name: "Total Ventas" },
    { id: "VALOR_TOPE", name: "Valor Tope" },
    { id: "SUPERA_PAGO_PARAFISCALES", name: "Supera Pago paraficales" },
    { id: "RESPUESTA_VALIDACION_FONTUR", name: "Respuesta Validación Fontur" },
    { id: "FECHA_ULTIMA_ACTUALIZACION", name: "Fecha Última Actualización" },
  ];

  constructor(
    private formBuilder: FormBuilder,
    private establecimientoComercioService: EstablecimientoComercioService,
    public authService: AuthService,
    private PagosParafiscalesService: PagosParafiscalesService
  ) {
    this.createPagingTable();
    this.createForm();

    const selectAllControl = new FormControl(false);
    const formControl = this.exportarList.map(
      (control) => new FormControl(false)
    );
    this.exportarForm = this.formBuilder.group({
      exportarList: new FormArray(formControl, this.minSelectCheckbox(1)),
      selectAll: selectAllControl,
    });

    this.selectUsuario = null;
    this.paginaActual = 1;
  }

  ngOnInit() {
    this.titleTable();
    this.onCamaraSelect();
    this.onCategoriaSelect();
    this.onSubcategoriaSelect();
    this.onChanges();
  }

  createForm() {
    this.filtro = this.formBuilder.group({
      codigo_camara: [null],
      fecha_inicial: [null],
      fecha_final: [null],
      categoria: [null],
      sub_categoria: [null],
    });

    this.formCheck = this.formBuilder.group({
      orders: new FormArray([]),
    });

    const selectAllControl = new FormControl(false);
    const formControl = this.exportarList.map(
      (control) => new FormControl(false)
    );
    this.exportarForm = this.formBuilder.group({
      exportarList: new FormArray(formControl, this.minSelectCheckbox(1)),
      selectAll: selectAllControl,
    });
  }

  createPagingTable() {
    this.dataTabla = {
      paging: {} as Paging,
    } as DatoPaginadoModel;
  }

  onConsultarPagosParafiscales(page: number) {
    this.PagosParafiscalesService.getDataTable({
      ...this.filtro.value,
      numeroPagina: page,
    }).subscribe((resultado) => {
      if (resultado.result) {
        this.dataTabla = resultado.data as DatoPaginadoModel;
      }
    });
  }

  onPaginado(value: number) {
    this.paginaActual = value;
    this.onConsultarPagosParafiscales(value);
  }

  filtrar() {
    this.paginaActual = 1;
    this.createPagingTable();
    this.onConsultarPagosParafiscales(1);
  }

  limpiar() {
    this.filtro.reset();
    this.titleTable();
    this.onCamaraSelect();
    this.onCategoriaSelect();
    this.onSubcategoriaSelect();
    this.onChanges();
    this.createPagingTable();
    this.dataTabla.items = [];
  }

  titleTable() {
    this.headerTabla = [
      "Cámara de comercio",
      "Número Rnt",
      "Nombre o Razón social",
      "Identificación RL",
      "Categoría",
      "Sub Categoría",
      "Último año renovación",
      "Solicitud",
      "Estado Solicitud",
      "Número Radicación",
      "Fecha Radicación",
      "Aplica Pago Parafiscales",
      "Total Ventas",
      "Valor Tope",
      "Supera Pago parafiscales",
      "Respuesta Validación Fontur",
      "Fecha Última Actualización",
    ];
  }

  onCamaraSelect() {
    this.establecimientoComercioService.getCamaras().subscribe((resultado) => {
      if (resultado) {
        this.camarasLista = resultado.data as Array<CamaraComercioEntry>;
        if (this.authService.getRolUser(RolesUsuario.AdministradorCC)) {
          this.filtro
            .get("codigo_camara")
            .patchValue(this.authService.getCamaraUser());
          this.camaraComercio = this.camarasLista.find(
            (x) => x.codigo_camara === this.authService.getCamaraUser()
          ).desc_camara;
        }
      }
    });
  }

  onCategoriaSelect() {
    this.PagosParafiscalesService.getCategoria().subscribe((resultado) => {
      if (resultado.result) {
        this.categoria = resultado.data;
      }
    });
  }

  onSubcategoriaSelect() {
    // tslint:disable-next-line:triple-equals
    if (this.filtro.value.categoria == null) {
      this.PagosParafiscalesService.getSubCategoria().subscribe((resultado) => {
        if (resultado.result) {
          this.sub_categoria = resultado.data;
        }
      });
    } else {
      this.PagosParafiscalesService.getSubCategoriaxCategoria(
        this.filtro.value.categoria
      ).subscribe((resultado) => {
        if (resultado.result) {
          this.sub_categoria = resultado.data;
        }
      });
    }
  }

  onChanges() {
    this.exportarForm.get("selectAll").valueChanges.subscribe((bool) => {
      this.exportarForm
        .get("exportarList")
        .patchValue(Array(this.exportarList.length).fill(bool), {
          emitEvent: false,
        });
    });

    this.exportarForm.get("exportarList").valueChanges.subscribe((val) => {
      const allSelected = val.every((bool) => bool);
      if (this.exportarForm.get("selecAll").value !== allSelected) {
        this.exportarForm
          .get("selectAll")
          .patchValue(allSelected, { emitEvent: false });
      }
    });
  }

  minSelectCheckbox(min = 1) {
    const validator: ValidatorFn = (formArray: FormArray) => {
      const totalSelected = formArray.controls
        .map((control) => control.value)
        .reduce((prev, next) => (next ? prev + next : prev), 0);
      return totalSelected >= min ? null : { required: true };
    };
    return validator;
  }

  submit() {
    const selectedPreferences = this.exportarForm.value.exportarList
      .map((checked, index) => (checked ? this.exportarList[index].id : null))
      .filter((value) => value !== null);

    this.columnasEnvio = selectedPreferences.join();

    this.PagosParafiscalesService.generarExportarPagosParafiscales({
      ...this.filtro.value,
      columnas: this.columnasEnvio,
    }).subscribe((resultado) => {
      if (resultado.type === HttpEventType.Response) {
        if (resultado.ok) {
          this.saveAsExcelFile(
            resultado.body,
            `reporte_pagosParafiscales.xlsx`
          );
        }
      }
    });
  }

  private saveAsExcelFile(data: any, fileName: string): void {
    FileSaver.saveAs(data, fileName);
  }

  onCheckDate(minDate: NgbDate) {
    this.fecha_inicio = {
      day: minDate.day,
      month: minDate.month,
      year: minDate.year,
    };
  }
}
